import React from 'react';
import {
    FeedDetailFooterBlock, CommentCountNumArea, 
    CommentCountNumText, FeedCommentContent, 
    CommentMoreButtonBlock, CommentMoreButton, 
    ArrowDownIconArea, ArrowDownIcon, InputBarOpenButton, 
    ProfileImageArea, CurrentUserProfileImg, Text,
    FeedDescriptionBlock, FeedDescription, ShowMoreBtn
    // FeedDescBlock, FeedDesc, ShowMoreBtnBlock, ShowMoreBtn
} from './style';
import FeedAndCommunityFooter from 'components/presenters/common/FeedAndCommunityFooter';
import FeedComment from 'components/presenters/feed/detail/FeedComment';
import appInfoContainer from 'auth/appInfoContainer';
import { includes } from 'lodash';

const FeedDetailFooter = ({
    feedItem, 
    userInfo, 
    addLikeRequest, 
    deleteLikeRequest, 
    commentList, 
    currentFeedNo, 
    handleCommentBottomModal, 
    loadNextComments, 
    insertedCommentList, 
    isLikeAnimation, 
    lottieOptions, 
    onClickComment, 
    onReplyClick,
    handleShowReply,
    replyList,
    handleNextLoadReply,
    handleReplyDeleteBottomModal,
    feedDescLimit,
    handleClickMore,
    index,
    showMoreFeedNoList,
    isDetailItem
}) => {
    return (
        <FeedDetailFooterBlock>
            <FeedAndCommunityFooter item={feedItem} addLikeRequest={addLikeRequest} deleteLikeRequest={deleteLikeRequest}  currentFeedNo={currentFeedNo} isLikeAnimation={isLikeAnimation} lottieOptions={lottieOptions} onClickComment={onClickComment}/>
            {feedItem?.description ? (
                <FeedDescriptionBlock>
                    <FeedDescription onClick={() => onClickComment(feedItem)}>
                        <span style={{fontWeight: 700}}>{'📝'}</span> &nbsp;
                        {feedItem?.is_show_desc && showMoreFeedNoList.includes(feedItem?.no) ? feedItem?.description : feedItem?.description?.split('\n')[0].slice(0, feedDescLimit)}
                    </FeedDescription>
                    {feedItem?.is_show_desc && showMoreFeedNoList.includes(feedItem?.no) ? null : (
                        <ShowMoreBtn onClick={() => handleClickMore(index)}>
                        ...더 보기
                    </ShowMoreBtn>
                    )}
                    
                </FeedDescriptionBlock>
            ) : null}
            {feedItem['total_comment'] ? 
                <CommentCountNumArea onClick={() => onClickComment(feedItem)}>
                    <CommentCountNumText>{`${feedItem['total_comment']}개의 댓글보기`}</CommentCountNumText>
                </CommentCountNumArea> 
                : null}
                {feedItem['total_comment'] !== null? 
                    <FeedCommentContent>
                    {insertedCommentList ? insertedCommentList.map((commentItem) => 
                        
                        <FeedComment 
                        key={`feed-added-comment-no-${commentItem['no']}`} 
                        onReplyClick={onReplyClick} 
                        userInfo={userInfo} 
                        commentItem={commentItem} 
                        handleCommentBottomModal={handleCommentBottomModal}
                        handleShowReply={handleShowReply}
                        replyList={replyList}
                        handleNextLoadReply={handleNextLoadReply}
                        handleReplyDeleteBottomModal={handleReplyDeleteBottomModal}
                        />
                        
                    ) : null}
                    {commentList? commentList.map((commentItem) => 
                            <FeedComment 
                                key={`feed-comment-no-${commentItem['no']}`} 
                                userInfo={userInfo} 
                                commentItem={commentItem} 
                                handleCommentBottomModal={handleCommentBottomModal} 
                                onReplyClick={onReplyClick}
                                handleShowReply={handleShowReply}
                                replyList={replyList}
                                handleNextLoadReply={handleNextLoadReply}
                                handleReplyDeleteBottomModal={handleReplyDeleteBottomModal}
                                /> 
                    ):null}
                    {/* {feedItem['total_comment'] && (commentList.length + insertedCommentList.length) !== parseInt(feedItem['total_comment']) ? 
                    <CommentMoreButtonBlock>
                        <CommentMoreButton onClick={() => loadNextComments(feedItem)}>댓글 더보기</CommentMoreButton>
                        <ArrowDownIconArea>
                            <ArrowDownIcon src={arrowDown} alt="arrow down icon" />
                        </ArrowDownIconArea>
                    </CommentMoreButtonBlock> 
                    : null} */}
                    </FeedCommentContent>
                : null}
                {(isDetailItem !== true)
                    ?(<InputBarOpenButton onClick={() => onClickComment(feedItem)}>
                        <ProfileImageArea>
                            <CurrentUserProfileImg src={`${appInfoContainer.imagePath}/user_profile_img/${userInfo['profile_img'] ? userInfo.profile_img : 'default_profile_1.png'}`}/>
                        </ProfileImageArea>
                        <Text>댓글을 달아보세요</Text>
                    </InputBarOpenButton>)
                    :(null)
                }
            
        </FeedDetailFooterBlock>
    );
}

export default FeedDetailFooter;